module.exports = __webpack_public_path__ + "img/empty_state_bookmarks.9eca75b3.png";